import { cva } from '@onbeam/business-styled-system/css';

export const breakout = cva({
  base: {
    position: 'relative',
    w: 'screen',
    left: '[50%]',
    transform: 'translateX(-50%)',
  },
});
